module.exports = __webpack_public_path__ + "static/media/Growth.bcbf7d96.png";